import * as index from '@syncfusion/ej2-schedule';
index.Schedule.Inject( index.Day,index.Week,index.WorkWeek,index.Month,index.Agenda,index.MonthAgenda);
export * from '@syncfusion/ej2-schedule';
